import { typeArray } from "../typeArray";

// export const setLoginDataAction = (payload) => {
// 	return {
// 	  type: typeArray.setLoginDataAction,
// 	  payload,
// 	};
//   };
//----------------------------------------------------------------
//----------------------------------------------------------------
//----------------------------------------------------------------
//----------------------------------------------------------------
//----------------------------------------------------------------
export const setLoginDataAction = (payload) => {
  return {
    type: typeArray.setLoginDataAction,
    payload,
  };
};

export const setUserProfile = (payload) => {
  return {
    type: typeArray.setUserProfile,
    payload,
  };
};
export const setProductList = (payload) => {
  return {
    type: typeArray.setProductList,
    payload,
  };
};

export const setTaskList = (payload) => {
  return {
    type: typeArray.setTaskList,
    payload,
  };
};
//
